const defaultIpListType = () => ({
  description: '',
  ips: [],
  name: '',
});

/**
 * @export IpListType constructor
 * @param  {} args={}
 * @param  {} defaultIpList=defaultIpListType()
 */
export default function IpListType(args = {}, defaultIpList = defaultIpListType()) {
  const data = {
    ...defaultIpList,
    ...args,
  };

  if (data.id) {
    this.id = data.id;
  }

  this.description = data.description || '';
  this.name = data.name || '';
  this.ips = data.ips || [];

  return this;
}
